@if(showWelcomeView){
    <sa-welcome-view></sa-welcome-view>
}
@if(maintenanceMode){
    <div style=" display: flex;justify-content: center;align-items: center;height: 100vh;margin: auto;max-width: 40rem;flex-direction: column;gap: 2rem;">

        <div class="brand">
          <a href="https://sarasanalytics.com/" data-wpel-link="internal">
            <span _ngcontent-nlh-c298="" class="daton-logo"></span>
          </a>
        </div>
        <div style=" color: #191616;font-size: 1rem;background: #EDF4FC;padding: 3rem;font-weight: 500;">
          <h1>We&rsquo;ll be back soon!</h1>
          <p style=" font-size: 1rem; font-weight: 500; ">
            We had to stop the UI services to troubleshoot an issue. We will restore the services asap and until then users won’t be able to configure new integrations or modify current integrations. Jobs in the backend are running as scheduled.
          </p>
          <p style=" font-size: 1rem; font-weight: 500; ">Sorry for the inconvenience but we&rsquo;re performing some maintenance at the moment. If you need to you can always <a href="mailto:support@sarasanalytics.com">contact us</a>, otherwise we&rsquo;ll be back online shortly!</p>
          <p style=" font-size: 1rem; font-weight: 500; ">&mdash; Daton Team</p>
        </div>
    </div>
}@else{
    <router-outlet></router-outlet>
}